module.exports = __webpack_public_path__ + "fonts/CircularStd-MediumItalic.dcb304fd.otf";